module.exports = __webpack_public_path__ + "static/img/pointer-reg.5040921.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pointer-reg.png
// module id = Vqe6
// module chunks = 1